import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Grid } from 'semantic-ui-react';
import { RootStoreContext } from '../../../app/stores/rootStore';
import { observer } from 'mobx-react-lite';
import { Pagination } from 'semantic-ui-react'
import ListItemPlaceHolder from '../../../app/common/PlaceHolder/ListItemPlaceHolder';
import BelieverList from './BelieverList';
import SearchAndSortForm from '../../../app/common/search/SearchAndSortForm';
import { BelieverStatus } from '../../../app/common/constants/believerStatus';
import { SortOrder } from '../../../app/common/constants/sortOrder';

const BelieverDashboard: React.FC = () => {
    const rootStore = useContext(RootStoreContext);
    const { getBelievers, loadBelievers, currentPage, setCurrentPage, totalPage, loadingInitial,
        deleteById } = rootStore.believerStore;

    const [sortOrderEntered, setSortOrderEntered] = useState<string>(SortOrder.NameAsc);
    const [searchEntered, setSearchEntered] = useState<string>('');

    const { openModal } = rootStore.modalStore;

    useEffect(() => {
        loadBelievers(BelieverStatus.Regular, sortOrderEntered, searchEntered,'');
    }, []);

    const searchHandler = (searchOrder:string, search:string)=>{
        setSortOrderEntered(searchOrder);
        setSearchEntered(search);
        loadBelievers(BelieverStatus.Regular, searchOrder, search,'');
    }

    const pageChangHandler = (event: React.MouseEvent<HTMLAnchorElement>, data: any) => {
        setCurrentPage(data.activePage);
        loadBelievers(BelieverStatus.Regular, sortOrderEntered, searchEntered,'');
    }

    return (
        <Grid style={{ marginTop: '15px' }}>
            <Grid.Column width={11}>
                {
                    loadingInitial ? <ListItemPlaceHolder /> :
                        (
                            <Fragment>
                                <BelieverList
                                    openModal ={openModal}
                                    deleteById = {deleteById}                                
                                    believers={getBelievers} />
                                <Pagination
                                    style={{marginTop:15}}
                                    firstItem={null}
                                    lastItem={null}
                                    defaultActivePage={currentPage} totalPages={totalPage}
                                    onPageChange={pageChangHandler}
                                />
                            </Fragment>
                        )
                }
            </Grid.Column>
            <Grid.Column width={5}>
                <SearchAndSortForm 
                    search={searchHandler}/> 
            </Grid.Column>
        </Grid>
    );
};

export default observer(BelieverDashboard);


